import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "sqg-currentFolder" }
const _hoisted_2 = { class: "sqg-currentFolder__line" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-currentFolder__title" }, "Informations générales", -1)
const _hoisted_4 = {
  key: 1,
  class: "sqg-currentFolder__items"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Nom: ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Créé le : ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Référent(s) : ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-currentFolder__title" }, "Etat d'avancement", -1)
const _hoisted_10 = { class: "sqg-currentFolder__line" }
const _hoisted_11 = { class: "sqg-currentFolder__title" }
const _hoisted_12 = { class: "sqg-currentFolder__items" }
const _hoisted_13 = { class: "sqg-currentFolder__title" }
const _hoisted_14 = { class: "sqg-currentFolder__items" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-alt" }, null, -1)
const _hoisted_17 = { class: "sqg-currentFolder__title" }
const _hoisted_18 = { class: "sqg-currentFolder__items" }
const _hoisted_19 = { class: "sqg-currentFolder__line" }
const _hoisted_20 = { class: "sqg-currentFolder__line" }
const _hoisted_21 = { class: "sqg-currentFolder__title" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Nouveau")
const _hoisted_23 = {
  key: 0,
  class: "sqg-currentFolder__addComment"
}
const _hoisted_24 = { class: "sqg-currentFolder__commentActions" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Valider")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Annuler")
const _hoisted_27 = { class: "sqg-currentFolder__commentTitle" }
const _hoisted_28 = { class: "sqg-currentFolder__content" }
const _hoisted_29 = { key: 2 }

import {onMounted, ref, watch} from "vue";
import {storeToRefs} from "pinia";
import {useFoldersStore} from "@/stores/folders";
import {useUserStore} from "@/stores/user";
import {beautifyName} from "@/functions/forms";
import {AxiosResponse} from "axios";
import {getRoleIcone, randomColor} from '@/functions/utils';
import Header from '@/components/Header.vue';
import Card from '@/components/Card.vue';
import CardButton from '@/components/CardButton.vue';
import Loader from '@/components/Loader.vue';
import Stepper from '@/components/Stepper.vue';
import Button from '@/components/Button.vue';
import Textarea from '@/components/TextArea.vue';

//STORE folders

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const foldersStore = useFoldersStore();
const { currentFolder, folderLoader } = storeToRefs(foldersStore);
//STORE users
const usersStore = useUserStore();
const { user, userLoader } = storeToRefs(usersStore);

//DATA
const comment = ref('');
const isAddCommentOn = ref(false);

const addComment = () => {
  foldersStore.addComment(currentFolder.value.id, comment.value).then(() => {
    isAddCommentOn.value = false;
    refreshFolder();
  });
};

const watchFolder = () => {
  foldersStore.follow(currentFolder.value.id).then(() => refreshFolder());
}

const unwatchFolder = () => {
  foldersStore.unfollow(currentFolder.value.id).then(() => refreshFolder());
}

const steps = ref([
  { name: 'Initialisation', stateT: 'initialisation', state: 'todo', step: 1 },
  { name: 'Configuration', stateT: 'configuration', state: 'todo', step: 2 },
  { name: 'Validation', stateT: 'validation', state: 'todo', step: 3 },
  { name: 'Montage', stateT: 'montage', state: 'todo', step: 4 },
  { name: 'Terminé', stateT: 'done', state: 'todo', step: 5 },
]);
const users = ref([]);

const nextStep = () => {
  foldersStore.nextStep(currentFolder.value.id).then(() => {
  refreshFolder();
  });
};

const previousStep = () => {
  foldersStore.previousStep(currentFolder.value.id).then(() => {
  refreshFolder();
  });
};

const cancelFolder = () => {
  foldersStore.cancelFolder(currentFolder.value.id).then(() => {
  refreshFolder();
  });
};

watch(() => user.value.preferences.currentFolderId, () => refreshFolder());

const refreshFolder = () => {
  foldersStore.getFolderById(user.value.preferences.currentFolderId).then(() => {
    //Fill stepper
    let find = false;
    steps.value.forEach((step) => {
      if (step.stateT === currentFolder.value.state) {
        step.state = 'inProgress';
        find = true;
      }
      else {
        !find ? step.state = 'done' : step.state = 'todo';
      }
    });
    usersStore.getUsersByFolder(user.value.preferences.currentFolderId).then((response: AxiosResponse) => {
      if (response.status === 200) {
        userLoader.value = false;
        users.value = response.data;
      }
    });
  })
};

const refreshCommentaries = () => {
  console.log('');
};

onMounted(async () => {
  refreshFolder();
  refreshCommentaries();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      icone: "fas fa-folder-open",
      title: _unref(currentFolder).name
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Card, {
        width: "30",
        class: "sqg-currentFolder__infos"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          (_unref(folderLoader))
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _hoisted_5,
                  _createElementVNode("strong", null, _toDisplayString(_unref(currentFolder).name), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _createElementVNode("strong", null, _toDisplayString(new Date(_unref(currentFolder).creationDate).toLocaleString()), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_7,
                  (_unref(currentFolder).followers.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Aucun ..."))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(currentFolder).followers, (follower) => {
                        return (_openBlock(), _createElementBlock("strong", {
                          key: follower.id
                        }, _toDisplayString(follower.mail), 1))
                      }), 128))
                ])
              ]))
        ]),
        _: 1
      }),
      _createVNode(Card, {
        width: "70",
        class: "sqg-currentFolder__steps"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          (_unref(folderLoader))
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : (_openBlock(), _createBlock(Stepper, {
                key: 1,
                steps: steps.value
              }, null, 8, ["steps"]))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(Card, {
        width: "100",
        height: "280px",
        class: "sqg-currentFolder__forms clickable",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/folder/${_unref(currentFolder).id}/forms`)))
      }, {
        default: _withCtx(() => [
          (_unref(folderLoader))
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(currentFolder).forms.length) + " Formulaires associés", 1),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentFolder).forms, (form, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "sqg-currentFolder__item",
                      key: index
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`sqg-currentFolder__mark -${form.formState}`)
                      }, null, 2),
                      _createTextVNode(_toDisplayString(_unref(beautifyName)(form.formType)), 1)
                    ]))
                  }), 128))
                ])
              ], 64))
        ]),
        _: 1
      }),
      _createVNode(Card, {
        width: "100",
        height: "280px",
        class: "sqg-currentFolder__files clickable",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/folder/${_unref(currentFolder).id}/files`)))
      }, {
        default: _withCtx(() => [
          (_unref(folderLoader))
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(currentFolder).files.length) + " Fichiers associés", 1),
                _createElementVNode("div", _hoisted_14, [
                  (_unref(currentFolder).files.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Aucun fichiers ..."))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(currentFolder).files, (file, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "sqg-currentFolder__item",
                          key: index
                        }, [
                          _hoisted_16,
                          _createTextVNode(_toDisplayString(file.fileName), 1)
                        ]))
                      }), 128))
                ])
              ], 64))
        ]),
        _: 1
      }),
      _createVNode(Card, {
        width: "100",
        height: "280px",
        class: "sqg-currentFolder__users clickable",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'FolderUsers', params: { folderId: _unref(currentFolder).id }})))
      }, {
        default: _withCtx(() => [
          (_unref(userLoader))
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(users.value.length) + " Utilisateurs associés", 1),
                _createElementVNode("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "sqg-currentFolder__item",
                      key: index
                    }, [
                      _createElementVNode("div", {
                        class: "sqg-currentFolder__nameIcon",
                        style: _normalizeStyle(`background-color: ${_unref(randomColor)(user.id)}`)
                      }, _toDisplayString(user.firstname[0]) + _toDisplayString(user.lastname[0]), 5),
                      _createTextVNode(_toDisplayString(user.firstname) + " " + _toDisplayString(user.lastname), 1)
                    ]))
                  }), 128))
                ])
              ], 64))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_unref(user).role === 'admin' || _unref(user).role === 'superAdmin')
        ? (_openBlock(), _createBlock(Card, {
            key: 0,
            width: "100",
            height: "120px",
            class: "sqg-currentFolder__actions clickable"
          }, {
            default: _withCtx(() => [
              (_unref(currentFolder).followers.find((follower) => follower.id === _unref(user).id))
                ? (_openBlock(), _createBlock(CardButton, {
                    key: 0,
                    width: "100",
                    icon: "fa-solid fa-eye-slash",
                    text: "Ne plus surveiller",
                    onClick: unwatchFolder
                  }))
                : (_openBlock(), _createBlock(CardButton, {
                    key: 1,
                    width: "100",
                    icon: "fa-solid fa-eye",
                    text: "Surveiller",
                    onClick: watchFolder
                  })),
              _createVNode(CardButton, {
                disabled: _unref(currentFolder).state === 'termine'  || _unref(currentFolder).state === 'annule',
                width: "100",
                icon: "fas fa-angle-double-right",
                text: "Etape suivante",
                onClick: nextStep
              }, null, 8, ["disabled"]),
              _createVNode(CardButton, {
                disabled: _unref(currentFolder).state === 'termine'  || _unref(currentFolder).state === 'annule',
                width: "100",
                icon: "fas fa-ban",
                text: "Annuler le dossier",
                onClick: cancelFolder
              }, null, 8, ["disabled"]),
              _createVNode(CardButton, {
                disabled: _unref(currentFolder).state === 'initialisation' || _unref(currentFolder).state === 'annule',
                width: "100",
                icon: "fas fa-angle-double-left",
                text: "Etape précédente",
                onClick: previousStep
              }, null, 8, ["disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(Card, {
        width: "100",
        height: "100%",
        class: "sqg-currentFolder__comments"
      }, {
        default: _withCtx(() => [
          (_unref(folderLoader))
            ? (_openBlock(), _createBlock(Loader, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_21, [
                  _createTextVNode("Commentaires (" + _toDisplayString(_unref(currentFolder).comments.length) + ")", 1),
                  (!isAddCommentOn.value)
                    ? (_openBlock(), _createBlock(Button, {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (isAddCommentOn.value = true))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                (isAddCommentOn.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(Textarea, {
                        modelValue: comment.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((comment).value = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(Button, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (addComment()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        }),
                        _createVNode(Button, {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (isAddCommentOn.value = false))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(currentFolder).comments.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(currentFolder).comments, (comment, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "sqg-currentFolder__comment",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", {
                            class: "sqg-currentFolder__nameIcon",
                            style: _normalizeStyle(`background-color: ${_unref(randomColor)(comment.authorId)}`)
                          }, _toDisplayString(comment.authorFirstname[0]) + _toDisplayString(comment.authorLastname[0]), 5),
                          _createTextVNode(" " + _toDisplayString(comment.authorFirstname) + " " + _toDisplayString(comment.authorLastname) + " - " + _toDisplayString(new Date(comment.creationDate).toLocaleString()), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, _toDisplayString(comment.content), 1)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, " Aucun commentaires ... "))
              ], 64))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})